<main [cdkTrapFocus]="isTrapActive" cdkTrapFocusAutoCapture class="layout-panel-centered">
    <form [formGroup]="step2" class="panel overflowing">
        <header class="panel-header">
            <h1 class="sr-only" i18n="sr-only@@profile.setupGiverProfile.title">Registrierungsprozess</h1>
            <ol aria-label="Schritte" class="process-steps heading">
                <li class="completed d-none d-sm-flex"><a [state]="navigateState"
                                                          i18n="@@profile.setupGiverOffer.profile"
                                                          routerLink="/on-boarding/giver-profile">1. Profil</a></li>
                <li class="completed"><a [state]="navigateState" aria-current="step"
                                         i18n="@@profile.setupGiverOffer.information"
                                         routerLink="/on-boarding/giver-profile-details">2. Angaben</a>
                </li>
                <li class="d-none d-sm-flex" i18n="@@profile.setupGiverOffer.assistance">3. Assistenz</li>
            </ol>
            <a class="cancel" i18n="@@profile.setupGiverOffer.btn.cancel" routerLink="/">Abbrechen</a>
        </header>
        <div class="panel-content transportation-illustration">
            <p class="text" i18n="@@profile.setupGiverProfileDetails.info.moreDetails">
                Um Sie mit passenden möglichen Arbeitgeber/innen (Assistenznehmende) in Verbindung zu bringen, brauchen
                wir einige Angaben von Ihnen. Diese Angaben sind nicht öffentlich zugänglich.
            </p>

            <app-giver-profile-details [form]="form" [parentGroup]="step2"></app-giver-profile-details>
            <!-- id is linked in .ts file -->
        </div>
        <div class="panel-footer">
            <button (click)="back()" class="button block-xs" i18n="@@profile.setupGiverOffer.btn.back" type="button">
                Zurück
            </button>
            <button (click)="next()" class="button primary block-xs" i18n="@@profile.setupGiverOffer.btn.next"
                    type="button">Weiter
            </button>
        </div>
    </form>
</main>
